export default {
    _prefix: "qualityFormEditor.visibilityCondition",
    labels: {
        visibilityConditionOperators: {
            AND: "all",
            OR: "any",
        },
        dropDownOptions: "Drop Down Options",
    },
};
